// localStorage-based test progress (true/false test mode)
const STORAGE_KEY = "bk_test_progress_v2";

const readAll = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

const writeAll = (data) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

// Per category: { correct: [factId], wrong: [factId], lastFinishedAt: iso, bestScorePct: number }
export const getTestProgress = (categoryId) => {
  const all = readAll();
  return (
    all[categoryId] || {
      correct: [],
      wrong: [],
      lastFinishedAt: null,
      bestScorePct: null,
    }
  );
};

export const recordAnswer = (categoryId, factId, isCorrect) => {
  const all = readAll();
  const cur = all[categoryId] || {
    correct: [],
    wrong: [],
    lastFinishedAt: null,
    bestScorePct: null,
  };
  // remove from either list first
  cur.correct = cur.correct.filter((id) => id !== factId);
  cur.wrong = cur.wrong.filter((id) => id !== factId);
  if (isCorrect) cur.correct.push(factId);
  else cur.wrong.push(factId);
  all[categoryId] = cur;
  writeAll(all);
  return cur;
};

export const finalizeTest = (categoryId, pct) => {
  const all = readAll();
  const cur = all[categoryId] || {
    correct: [],
    wrong: [],
    lastFinishedAt: null,
    bestScorePct: null,
  };
  cur.lastFinishedAt = new Date().toISOString();
  if (cur.bestScorePct == null || pct > cur.bestScorePct) {
    cur.bestScorePct = pct;
  }
  all[categoryId] = cur;
  writeAll(all);
  return cur;
};

export const resetTestProgress = (categoryId) => {
  const all = readAll();
  delete all[categoryId];
  writeAll(all);
};
